import { c as _c } from "react/compiler-runtime";
import type { PropsWithChildren } from 'react';
import { LiraContainerIds } from '@/client/components/Adv/Lira/liraContainerIds';
import { SkeletonWithAdv } from '@/client/components/Adv/SkeletonWithAdv';
type Props = {
  noAdvToggle?: string | null;
  noAdvAdvertiser?: boolean;
};
const SkeletonWithAdvForAdView = t0 => {
  const $ = _c(9);
  const {
    children,
    noAdvToggle,
    noAdvAdvertiser
  } = t0;
  const enabled = noAdvToggle !== "B" && !noAdvAdvertiser;
  let t1;
  let t2;
  let t3;
  if ($[0] !== enabled) {
    t1 = {
      id: LiraContainerIds.adView.skyscraperLeft,
      enabled
    };
    t2 = {
      id: LiraContainerIds.adView.skyscraperRight,
      enabled
    };
    t3 = {
      id: LiraContainerIds.adView.top,
      enabled
    };
    $[0] = enabled;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== children || $[5] !== t1 || $[6] !== t2 || $[7] !== t3) {
    t4 = <SkeletonWithAdv skyscraperLeft={t1} skyscraperRight={t2} billboard={t3}>{children}</SkeletonWithAdv>;
    $[4] = children;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
export { SkeletonWithAdvForAdView };